import {
    type ApiResult,
    type BaseParams,
    type GenerateLootBoxesRequest,
    links,
    type LootBox,
    type LootBoxId,
    type LootBoxType,
    type LootBoxTypeId,
    type PaginatedResult,
    type PagingParams,
    type PostParams,
    Request,
    type UpdateLootBoxesRequest,
} from '@app/client';

export async function getTypes(params: BaseParams<PagingParams>): Promise<ApiResult<LootBoxType[]>> {
    return Request.getRequest<LootBoxType[]>({
        ...params,
        target: links.lootBoxes().types.collection(),
    });
}

export async function newType(params: BaseParams & PostParams<LootBoxType>): Promise<ApiResult<LootBoxType>> {
    return Request.postRequest<LootBoxType>({
        ...params,
        target: links.lootBoxes().types.collection(),
        settings: {
            ...params.settings,
        },
    });
}

export async function generateLootBoxes(
    params: BaseParams & PostParams<GenerateLootBoxesRequest>,
): Promise<ApiResult<LootBox>> {
    return Request.postRequest<LootBox>({
        ...params,
        target: links.lootBoxes().types.generate(),
        settings: {
            ...params.settings,
        },
    });
}

export async function getLootBoxes(params: BaseParams<PagingParams>): Promise<ApiResult<PaginatedResult<LootBox>>> {
    return Request.getRequest<PaginatedResult<LootBox>>({
        ...params,
        target: links.lootBoxes().collection(),
    });
}

export async function removeLootBox(params: BaseParams & { id: LootBoxTypeId }): Promise<ApiResult<LootBoxType>> {
    return Request.deleteRequest<LootBoxType>({
        ...params,
        target: links.lootBoxes().single(params.id),
        settings: {
            ...params.settings,
        },
    });
}

export async function updateLootBox(
    params: BaseParams & PostParams<UpdateLootBoxesRequest> & { id: LootBoxTypeId },
): Promise<ApiResult<LootBoxId>> {
    return Request.patchRequest<LootBoxId>({
        ...params,
        target: links.lootBoxes().single(params.id),
        settings: {
            ...params.settings,
        },
    });
}
